/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundRef,
  DonationFundRefOptional,
  DonationFundRefMetaI,
  DonationFundRefTrackedI,
} from "./donation-fund-ref";
import {
  DonationFundRefTracked,
  DonationFundRefMeta,
} from "./donation-fund-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationPurposeBase,
  DonationPurposeBaseOptional,
  DonationPurposeBaseMetaI,
  DonationPurposeBaseTrackedI,
} from "./donation-purpose-base";
import {
  DonationPurposeBaseTracked,
  DonationPurposeBaseMeta,
} from "./donation-purpose-base";

/**
 *
 * @export
 * @interface DonationInitiativeBase
 */
export interface DonationInitiativeBaseOptional extends DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  initiativeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isFeatured?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isGoalPublic?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  contributionsGoal?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeBase
   */
  targetFund?: DonationFundRefOptional;
}

export interface DonationInitiativeBase
  extends DonationInitiativeBaseOptional, DonationPurposeBase {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  initiativeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isFeatured?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isGoalPublic?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  contributionsGoal?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeBase
   */
  targetFund?: DonationFundRef;
}

export interface DonationInitiativeBaseTrackedI extends DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  showInCheckout?: boolean;
  showInCheckoutIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  portalDescription?: string;
  portalDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationInitiativeBase
   */
  initiativeName?: string;
  initiativeNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isFeatured?: boolean;
  isFeaturedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationInitiativeBase
   */
  isGoalPublic?: boolean;
  isGoalPublicIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationInitiativeBase
   */
  contributionsGoal?: number;
  contributionsGoalIsSet: boolean;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationInitiativeBase
   */
  targetFund?: DonationFundRefTrackedI;
  targetFundIsSet: boolean;
}

transformDatesMap.set(
  "DonationInitiativeBase",
  function (model: DonationInitiativeBase) {
    const transformDatestargetFund = transformDatesMap.get("DonationFundRef");
    if (transformDatestargetFund && model.targetFund) {
      transformDatestargetFund(model.targetFund);
    }
  },
);

export type DonationInitiativeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  showInCheckout: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  portalDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  initiativeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isFeatured: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isGoalPublic: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  contributionsGoal: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  targetFund: PropertyMeta<DonationFundRefMetaI>;
}>;

export var DonationInitiativeBaseMeta: DonationInitiativeBaseMetaI =
  {} as DonationInitiativeBaseMetaI;
DonationInitiativeBaseMeta = typeMeta("DonationInitiativeBase", {
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  showInCheckout: propertyMeta(
    "showInCheckout",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  portalDescription: propertyMeta(
    "portalDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  initiativeName: propertyMeta(
    "initiativeName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isFeatured: propertyMeta(
    "isFeatured",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isGoalPublic: propertyMeta(
    "isGoalPublic",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  contributionsGoal: propertyMeta(
    "contributionsGoal",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  targetFund: propertyMeta(
    "targetFund",
    false,
    false,
    false,
    DonationFundRefMeta,
  ),
});

const metaI = DonationInitiativeBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DonationPurposeBaseMeta]);
  metaI.active.inheritedFrom = DonationPurposeBaseMeta.active;
  metaI.displayOrder.inheritedFrom = DonationPurposeBaseMeta.displayOrder;
  metaI.showInCheckout.inheritedFrom = DonationPurposeBaseMeta.showInCheckout;
  metaI.portalDescription.inheritedFrom =
    DonationPurposeBaseMeta.portalDescription;
  metaI.imageURL.inheritedFrom = DonationPurposeBaseMeta.imageURL;
});

export class DonationInitiativeBaseTracked
  extends DonationPurposeBaseTracked
  implements DonationInitiativeBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  showInCheckout__I?: boolean = undefined;
  showInCheckoutIsSet: boolean = false;
  set showInCheckout(v: undefined | boolean) {
    if (v !== undefined) {
      this.showInCheckout__I = v;
      this.showInCheckoutIsSet = true;
    } else {
      this.showInCheckout__I = v || undefined;
      this.showInCheckoutIsSet = false;
    }
    this.changeTracker = true;
  }
  get showInCheckout() {
    return this.showInCheckout__I;
  }
  portalDescription__I?: string = undefined;
  portalDescriptionIsSet: boolean = false;
  set portalDescription(v: undefined | string) {
    if (v !== undefined) {
      this.portalDescription__I = v;
      this.portalDescriptionIsSet = true;
    } else {
      this.portalDescription__I = v || undefined;
      this.portalDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get portalDescription() {
    return this.portalDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  initiativeName__I?: string = undefined;
  initiativeNameIsSet: boolean = false;
  set initiativeName(v: undefined | string) {
    if (v !== undefined) {
      this.initiativeName__I = v;
      this.initiativeNameIsSet = true;
    } else {
      this.initiativeName__I = v || undefined;
      this.initiativeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get initiativeName() {
    return this.initiativeName__I;
  }
  isFeatured__I?: boolean = undefined;
  isFeaturedIsSet: boolean = false;
  set isFeatured(v: undefined | boolean) {
    if (v !== undefined) {
      this.isFeatured__I = v;
      this.isFeaturedIsSet = true;
    } else {
      this.isFeatured__I = v || undefined;
      this.isFeaturedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isFeatured() {
    return this.isFeatured__I;
  }
  isGoalPublic__I?: boolean = undefined;
  isGoalPublicIsSet: boolean = false;
  set isGoalPublic(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGoalPublic__I = v;
      this.isGoalPublicIsSet = true;
    } else {
      this.isGoalPublic__I = v || undefined;
      this.isGoalPublicIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGoalPublic() {
    return this.isGoalPublic__I;
  }
  contributionsGoal__I?: number = undefined;
  contributionsGoalIsSet: boolean = false;
  set contributionsGoal(v: undefined | number) {
    if (v !== undefined) {
      this.contributionsGoal__I = v;
      this.contributionsGoalIsSet = true;
    } else {
      this.contributionsGoal__I = v || undefined;
      this.contributionsGoalIsSet = false;
    }
    this.changeTracker = true;
  }
  get contributionsGoal() {
    return this.contributionsGoal__I;
  }
  targetFund__I?: DonationFundRefTracked = undefined;
  targetFundIsSet: boolean = false;
  set targetFund(v: undefined | DonationFundRefTracked) {
    if (v !== undefined) {
      this.targetFund__I = v;
      this.targetFundIsSet = true;
    } else {
      this.targetFund__I = v || undefined;
      this.targetFundIsSet = false;
    }
    this.changeTracker = true;
  }
  get targetFund() {
    return this.targetFund__I;
  }
  constructor(
    config?: DonationInitiativeBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.targetFund?.setIds();
  }
  assignFrom(
    config: DonationInitiativeBaseOptional,
    options?: AssignOptions,
  ): DonationInitiativeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.showInCheckout &&
      this.showInCheckoutApplyFilter(optionsRequired.filter)
    ) {
      this.showInCheckout = config.showInCheckout;
      if (optionsRequired.unassign) this.showInCheckoutIsSet = false;
      else this.showInCheckoutIsSet = true;
    }
    if (
      config.portalDescription &&
      this.portalDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.portalDescription = config.portalDescription;
      if (optionsRequired.unassign) this.portalDescriptionIsSet = false;
      else this.portalDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (
      config.initiativeName &&
      this.initiativeNameApplyFilter(optionsRequired.filter)
    ) {
      this.initiativeName = config.initiativeName;
      if (optionsRequired.unassign) this.initiativeNameIsSet = false;
      else this.initiativeNameIsSet = true;
    }
    if (
      config.isFeatured &&
      this.isFeaturedApplyFilter(optionsRequired.filter)
    ) {
      this.isFeatured = config.isFeatured;
      if (optionsRequired.unassign) this.isFeaturedIsSet = false;
      else this.isFeaturedIsSet = true;
    }
    if (
      config.isGoalPublic &&
      this.isGoalPublicApplyFilter(optionsRequired.filter)
    ) {
      this.isGoalPublic = config.isGoalPublic;
      if (optionsRequired.unassign) this.isGoalPublicIsSet = false;
      else this.isGoalPublicIsSet = true;
    }
    if (
      config.contributionsGoal &&
      this.contributionsGoalApplyFilter(optionsRequired.filter)
    ) {
      this.contributionsGoal = config.contributionsGoal;
      if (optionsRequired.unassign) this.contributionsGoalIsSet = false;
      else this.contributionsGoalIsSet = true;
    }
    if (
      config.targetFund &&
      this.targetFundApplyFilter(optionsRequired.filter)
    ) {
      this.targetFund = new DonationFundRefTracked(config.targetFund, options);
      if (optionsRequired.unassign) this.targetFundIsSet = false;
      else this.targetFundIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationInitiativeBaseTrackedI {
    const cloned = {} as DonationInitiativeBaseTrackedI;
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.showInCheckoutIsSetDeep() &&
      this.showInCheckoutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.showInCheckoutIsSet = true;
      cloned.showInCheckout = this.showInCheckout;
    } else {
      //cloned.showInCheckoutIsSet = false
    }
    if (
      this.portalDescriptionIsSetDeep() &&
      this.portalDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.portalDescriptionIsSet = true;
      cloned.portalDescription = this.portalDescription;
    } else {
      //cloned.portalDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.initiativeNameIsSetDeep() &&
      this.initiativeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.initiativeNameIsSet = true;
      cloned.initiativeName = this.initiativeName;
    } else {
      //cloned.initiativeNameIsSet = false
    }
    if (
      this.isFeaturedIsSetDeep() &&
      this.isFeaturedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isFeaturedIsSet = true;
      cloned.isFeatured = this.isFeatured;
    } else {
      //cloned.isFeaturedIsSet = false
    }
    if (
      this.isGoalPublicIsSetDeep() &&
      this.isGoalPublicApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGoalPublicIsSet = true;
      cloned.isGoalPublic = this.isGoalPublic;
    } else {
      //cloned.isGoalPublicIsSet = false
    }
    if (
      this.contributionsGoalIsSetDeep() &&
      this.contributionsGoalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.contributionsGoalIsSet = true;
      cloned.contributionsGoal = this.contributionsGoal;
    } else {
      //cloned.contributionsGoalIsSet = false
    }
    if (
      this.targetFundIsSetDeep() &&
      this.targetFundApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetFundIsSet = true;
      cloned.targetFund = this.targetFund?.removeUnset(filter);
    } else {
      //cloned.targetFundIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationInitiativeBaseTrackedI {
    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.showInCheckoutApplyFilter(filter))
      this.showInCheckoutIsSet = false;

    if (!this.portalDescriptionApplyFilter(filter))
      this.portalDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.initiativeNameApplyFilter(filter))
      this.initiativeNameIsSet = false;

    if (!this.isFeaturedApplyFilter(filter)) this.isFeaturedIsSet = false;

    if (!this.isGoalPublicApplyFilter(filter)) this.isGoalPublicIsSet = false;

    if (!this.contributionsGoalApplyFilter(filter))
      this.contributionsGoalIsSet = false;

    if (!this.targetFundApplyFilter(filter)) this.targetFundIsSet = false;
    this.targetFund?.unassignAll(filter);

    return this;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.active,
      DonationInitiativeBaseMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.displayOrder,
      DonationInitiativeBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  showInCheckoutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.showInCheckout,
      DonationInitiativeBaseMeta,
      this.showInCheckout,
      this,
    );
  }
  showInCheckoutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.showInCheckoutIsSet && this.showInCheckoutApplyFilter(filter))
      return true;

    return false;
  }
  portalDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.portalDescription,
      DonationInitiativeBaseMeta,
      this.portalDescription,
      this,
    );
  }
  portalDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.portalDescriptionIsSet &&
      this.portalDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.imageURL,
      DonationInitiativeBaseMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  initiativeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.initiativeName,
      DonationInitiativeBaseMeta,
      this.initiativeName,
      this,
    );
  }
  initiativeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.initiativeNameIsSet && this.initiativeNameApplyFilter(filter))
      return true;

    return false;
  }
  isFeaturedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.isFeatured,
      DonationInitiativeBaseMeta,
      this.isFeatured,
      this,
    );
  }
  isFeaturedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isFeaturedIsSet && this.isFeaturedApplyFilter(filter)) return true;

    return false;
  }
  isGoalPublicApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.isGoalPublic,
      DonationInitiativeBaseMeta,
      this.isGoalPublic,
      this,
    );
  }
  isGoalPublicIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGoalPublicIsSet && this.isGoalPublicApplyFilter(filter))
      return true;

    return false;
  }
  contributionsGoalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.contributionsGoal,
      DonationInitiativeBaseMeta,
      this.contributionsGoal,
      this,
    );
  }
  contributionsGoalIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.contributionsGoalIsSet &&
      this.contributionsGoalApplyFilter(filter)
    )
      return true;

    return false;
  }
  targetFundApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationInitiativeBaseMeta.targetFund,
      DonationInitiativeBaseMeta,
      this.targetFund,
      this,
    );
  }
  targetFundIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetFundIsSet && this.targetFundApplyFilter(filter)) return true;
    return this.targetFund?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.showInCheckoutIsSetDeep(filter)) return true;
    if (this.portalDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.initiativeNameIsSetDeep(filter)) return true;
    if (this.isFeaturedIsSetDeep(filter)) return true;
    if (this.isGoalPublicIsSetDeep(filter)) return true;
    if (this.contributionsGoalIsSetDeep(filter)) return true;
    if (this.targetFundIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
